export enum TimeUnits {
    Minutes = "minutes",
    Hours = "hours",
    Days = "days",
    Weeks = "weeks",
    Months = "months",
}

export function getSecondsForTimeUnit(timeUnit: TimeUnits): number {
    switch (timeUnit) {
        case TimeUnits.Minutes:
            return 60;
        case TimeUnits.Hours:
            return 3600;
        case TimeUnits.Days:
            return 86400;
        case TimeUnits.Weeks:
            return 604800;
        case TimeUnits.Months:
            return 2592000;
        default:
            throw new Error(`getSecondsForTimeUnit: Time unit ${timeUnit} is not supported`);
    }
}

/**
 * Determines the appropriate time unit for the given number of seconds.
 *
 * @param seconds - The number of seconds to evaluate.
 * @param timeUnits - An optional array of time units to check, in descending order of duration
 * to ensure the largest possible time unit is returned.
 *
 * @returns The matching time unit from the provided list.
 *
 * @throws Will throw an error if no matching time unit is found.
 */
export function getTimeUnitFromSeconds(seconds: number, timeUnits: TimeUnits[]): TimeUnits {
    for (const timeUnit of timeUnits) {
        if (seconds % getSecondsForTimeUnit(timeUnit) === 0) {
            return timeUnit;
        }
    }
    throw new Error(`getTimeUnitFromSeconds: Time unit for ${seconds} seconds is not supported`);
}

export function getWaitActionSupportedTimeUnits(): TimeUnits[] {
    // In descending order
    return [TimeUnits.Weeks, TimeUnits.Days];
}
